<a (click)="toggleGroup($event)" [sqHtmlAttributes]="item.attributes" class="nav-link nav-group-toggle" href>
    <ng-container *ngTemplateOutlet="iconTemplate; context: { $implicit: item }" />
    <ng-container>{{ item.name }}</ng-container>
    @if (helper.hasBadge(item)) {
        <span [ngClass]="item | sidebarNavBadge">{{ item.badge.text }}</span>
    }
</a>
<sq-sidebar-nav [compact]="compact" [dropdownMode]="dropdownMode" [groupItems]="true" [navItems]="navItems" />

<ng-template #iconTemplate let-item>
    <!--  <i *ngIf="item?.icon" [ngClass]="item | cSidebarNavIcon"></i>-->
    @if (item?.icon) {
        <span class="nav-icon">
            <span [ngClass]="item.icon ?? ''"></span>
        </span>
    }
    @if (item?.faIcon) {
        <div class="nav-icon">
            <fa-icon [icon]="item.faIcon"></fa-icon>
        </div>
    }
    @if (!item?.icon && !item?.faIcon) {
        <span [ngClass]="item | sidebarNavIcon"></span>
    }
</ng-template>
